var customFirstLoad = true;
let customSessionId = 0; // isolate from color filter session
const customFilters = document.querySelectorAll(".js-custom-term");
const customProductListWrapper = document.querySelector(".non-ajaxinate-container");
const customProductList = customProductListWrapper.querySelector(".product-listing");

function matchesFilterTerm(title, term) {
  const parts = term.split(" ").map(t => t.trim().toLowerCase());
  const lowerTitle = title.toLowerCase();
  console.log(parts);
  console.log(lowerTitle);
  return parts.every(p => {
    const regex = new RegExp(`\\b${p}\\b`, "i");
    return regex.test(lowerTitle);
  });
}

function normalizeFilterTerm(value) {
  return value.toLowerCase().replace(/&/g, "_");
}

function getCustomBaseUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete("page");
  return url.toString();
}

// Main filtering function
async function applyCustomFilter(clicked) {
    customSessionId++;
    let selectedFilters = [];
    document
      .querySelectorAll(".js-custom-term.collection-filters__filter-list-item--active")
      .forEach((el) => {
        selectedFilters.push(normalizeFilterTerm(el.getAttribute("data-filter")));
      });

    document.querySelector(".products-loading").classList.add("hide");

    if(clicked) {
        document.querySelector(".container-full").scrollIntoView({ behavior: "smooth", block: "start" });
    }

    if (selectedFilters.length === 0) {
      if (customFirstLoad) {
        customFirstLoad = false;
        return;
      }
      // No filter → show original infinite scroll
      customProductList.innerHTML = "";
      customProductListWrapper.classList.add('hide');
      document.querySelector(".ajaxinate-container").classList.remove("hide");
      return;
    }

    customProductList.innerHTML = "";
    document.querySelector(".products-loading").classList.remove("hide");
    customProductListWrapper.classList.remove('hide');
    document.querySelector(".ajaxinate-container").classList.add("hide");
    await loadCustomProducts(getCustomBaseUrl(), selectedFilters, 1, customSessionId);
}

async function loadCustomProducts(baseUrl, filters, page, sessionId) {
    if (sessionId !== customSessionId) return;

    let nextLink = null;
    if (page <= 10 || (page > 10 && customProductList.children.length > 0)) {
      const urlObj = new URL(baseUrl, window.location.origin);
      urlObj.searchParams.set("page", page);

      const res = await fetch(urlObj.toString());
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "text/html");

      const products = [...doc.querySelectorAll(".product")];
      nextLink = doc.querySelector("a.paginate-next");

      // Filter matches
      let matches = [];
      if (filters.length > 0) {
        matches = products.filter((p) => {
          const title = p.querySelector('.card-title').getAttribute("data-product-title") || "";
          return filters.some((f) => matchesFilterTerm(title, f));
        });
      } else {
        matches = products;
      }

      if (sessionId !== customSessionId) return;

      if (matches.length > 0) {
        document.querySelector(".products-loading").classList.add("hide");
      }

      matches.forEach((p) => {
        customProductList.appendChild(p);
      });
    }

    if (nextLink && sessionId === customSessionId) {
      const nextPage = page + 1;
      setTimeout(() => {
        loadCustomProducts(baseUrl, filters, nextPage, sessionId);
      }, 0);
    } else {
      if (!customProductList.children.length) {
        document.querySelector(".products-loading").classList.add("hide");
        customProductList.innerHTML = `<p>No products found for selected filter options.</p>`;
      }
    }
}

// Load selected filters from URL
const customParams = new URLSearchParams(location.search);
const customSelected = new Set(customParams.getAll("custom_filter").map(normalizeFilterTerm));
customFilters.forEach((li) => {
    const val = normalizeFilterTerm(li.getAttribute("data-filter"));
    if (customSelected.has(val)) {
        li.classList.add("collection-filters__filter-list-item--active");
    }
});

// Click handler for custom filters
document.querySelectorAll(".js-custom-term .collection-filters__filter-list-item-text").forEach((a) => {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".js-custom-term");
      // toggle single active filter (like color behavior)
    //   document.querySelectorAll(".js-custom-term.collection-filters__filter-list-item--active")
    //     .forEach((el) => {
    //       if (el !== parent) {
    //         el.classList.remove("collection-filters__filter-list-item--active");
    //       }
    //     });

      parent.classList.toggle("collection-filters__filter-list-item--active");
      applyCustomFilter(true);
    });
});

applyCustomFilter(false);